import api from "../api/client";

const acompanhamentoApi = {
  /* Lista paginada por cursor da tela de acompanhamento — GET /v1/acompanhamento/fretes */
  listarFretes(params) {
    return api.get("/v1/acompanhamento/fretes", { params });
  },

  /* Um frete, com motorista e placa resolvidos — GET /v1/acompanhamento/fretes/:id */
  buscarFrete(idFreight) {
    return api.get(`/v1/acompanhamento/fretes/${idFreight}`);
  },

  /* Uma linha por frete com o tempo medido — GET /v1/acompanhamento/relatorios/fretes */
  listarRelatorio(params) {
    return api.get("/v1/acompanhamento/relatorios/fretes", { params });
  },

  /* Linha do tempo de um frete — GET /v1/acompanhamento/relatorios/fretes/:id */
  relatorioDoFrete(idFreight, params) {
    return api.get(`/v1/acompanhamento/relatorios/fretes/${idFreight}`, {
      params,
    });
  },

  /* Trajeto percorrido, já resumido — GET /v1/acompanhamento/fretes/:id/trajeto */
  buscarTrajeto(idFreight, params) {
    return api.get(`/v1/acompanhamento/fretes/${idFreight}/trajeto`, {
      params,
    });
  },

  /* O que chegou desde a última consulta do mapa ao vivo — GET .../fretes/:id/trajeto/novidades */
  novidadesDoTrajeto(idFreight, params) {
    return api.get(
      `/v1/acompanhamento/fretes/${idFreight}/trajeto/novidades`,
      { params },
    );
  },

  /* Estado do link que o cliente abre sem login — GET .../fretes/:id/link-publico */
  buscarLinkPublico(idFreight) {
    return api.get(`/v1/acompanhamento/fretes/${idFreight}/link-publico`);
  },

  /* Gera o link. Com um ativo, só com `substituir` — POST .../fretes/:id/link-publico */
  gerarLinkPublico(idFreight, { validadeHoras, substituir }) {
    return api.post(`/v1/acompanhamento/fretes/${idFreight}/link-publico`, {
      validadeHoras,
      ...(substituir ? { substituir: true } : {}),
    });
  },

  /* Desativa o link na hora — DELETE .../fretes/:id/link-publico */
  desativarLinkPublico(idFreight) {
    return api.delete(`/v1/acompanhamento/fretes/${idFreight}/link-publico`);
  },
};

export default acompanhamentoApi;
